import { Link } from 'react-router-dom'

import AnnouncementBannerWrapper from 'components/common/AnnouncementBannerWrapper'
import Button from 'components/common/Button'
import Text from 'components/common/Text'
import theme from 'theme'

import TrackedExternalLink from './common/TrackedExternalLink'

const VisualizationWelcomeBanner = (props) => {
  return (
    <AnnouncementBannerWrapper
      data-test-visualization-welcome-banner
      css={{
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        alignItems: 'center'
      }}
      {...props}
    >
      <div>
        <div
          css={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            gap: theme.space[2]
          }}
        >
          <Text as="h4" color="white">
            See the impact of your attacks in real time
          </Text>
        </div>
        <Text
          as="h5"
          color="white"
          css={{
            marginTop: theme.space[2],
            fontWeight: theme.fontWeights[0]
          }}
        >
          Our visualization graphs enable monitoring of your attacks in real
          time.{' '}
          <TrackedExternalLink
            color="green"
            href="https://www.gremlin.com/docs/infrastructure-layer/attacks/#monitor-attacks-in-real-time"
          >
            Learn more
          </TrackedExternalLink>
        </Text>
      </div>

      <div
        css={{
          zIndex: 1
        }}
      >
        <Button secondary as={Link} to="/settings/preferences">
          Enable for your team
        </Button>
      </div>
    </AnnouncementBannerWrapper>
  )
}

export default VisualizationWelcomeBanner
